enum SubPages {
    NewModel = "NewModel",
    MyModels = "MyModels",
    Account = "Account",
    Dashboard = "Dashboard",
    FinancialModelEditor = "FinancialModelEditor",
    OperationalModelEditor = "OperationalModelEditor",
    FinancialStatements = "FinancialStatements",
    Audit = "Audit",
    History = "History",
    Tools = "Tools",
    Compare = "Compare",
    CalculationResults = "CalculationResults",
    Settings = "Settings",
    Organization = "Organization",
    MyAccount = "MyAccount",
    Contact = "Contact",
    AI = "AI",
    Library = "Library",
    Portfolio = "Portfolio",
}

export default SubPages